import React from "react";
import { DataControlUI } from "@core/components/DataControlUI";
import { useDataControl } from "@core/hooks/useDataControl";
import { AuthRequired } from "@core/components/AuthRequired";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

export default function DataControl() {
  const dataControl = useDataControl("form");

  return (
    <AuthRequired>
      <div className="min-h-screen bg-gray-50">
        {/* Barre haute avec connexion */}
        <ProductHeader productType="form" showAuth={true} />

        {/* Contenu principal avec sidebar */}
        <div className="flex">
          {/* Sidebar auto-suffisante avec son hamburger */}
          <ProductSidebar productType="form" />

          {/* Contenu principal */}
          <div className="flex-1">
            <DataControlUI productType="form" {...dataControl} />
          </div>
        </div>
      </div>
    </AuthRequired>
  );
}
